import { AsyncState, loadingAsyncState } from "widgets-for-react"
import { CMSFooterItem } from "../cmsPage.state"
import { Drupal } from "../drupal/api"
import { DisplayType, getDisplaySize } from "../header/siteHeader/cmsSiteHeader.state"
import { getLangFromUrl } from "../utils/history"

export type CMSFooterState = {
  menuItems: AsyncState<CMSFooterItem[]>
  copyrightMenuItems: AsyncState<CMSFooterItem[]>
  displayType: DisplayType

  email?: string
}

export const initCMSFooterState = ():CMSFooterState => 
({
  menuItems: loadingAsyncState(() => Drupal.getFooter(getLangFromUrl())),
  copyrightMenuItems: loadingAsyncState(() => Drupal.getFooter(getLangFromUrl())),
  displayType: getDisplaySize()
})
